import React, { Component } from 'react';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import AjaxHandler from '../../../commons/ajax/AjaxHandler.js';
import Security from '../../../commons/security/Security.js';
import * as Utils from '../../../commons/utils/Utils.js';

const URL_OCIOSIDAD_V2 = '/disponibilidad/reglas/ociosidad-v2';
const VALOR_DIA_VENCIDO = 'DIA_VENCIDO';

class ReglasOciosidadV2Card extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();
    this.state = {
      loading: false,
      reglas: [],
      errorBackend: null,
      form: {
        dias_sin_ruta: '',
        ventana_procesamiento: VALOR_DIA_VENCIDO,
        fecha_desde: '',
        fecha_desde_grilla: '',
      },
      formError: null,
      guardado: false,
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.ajaxHandler.subscribe(this);
    this.cargarReglas();
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  cargarReglas() {
    this.setState({ loading: true, errorBackend: null });
    this.ajaxHandler
      .getJson(URL_OCIOSIDAD_V2)
      .then((data) => {
        this.setState({ reglas: data || [] });
      })
      .catch((error) => {
        this.ajaxHandler.handleError(error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleFormChange(event) {
    const { name, value } = event.target;
    this.setState((prev) => ({
      form: Object.assign({}, prev.form, { [name]: value }),
      formError: null,
      guardado: false,
    }));
  }

  handleSubmit(event) {
    event.preventDefault();
    const { form } = this.state;
    const intl = this.props.intl;

    const dias = parseInt(form.dias_sin_ruta, 10);
    if (isNaN(dias) || dias < 1) {
      this.setState({
        formError: intl.formatMessage({
          id: 'reglas.ociosidad_v2.validacion.dias_sin_ruta',
          defaultMessage: 'Los días sin ruta deben ser al menos 1',
        }),
      });
      return;
    }

    if (!form.fecha_desde) {
      this.setState({
        formError: intl.formatMessage({
          id: 'reglas.ociosidad_v2.validacion.fecha_requerida',
          defaultMessage: 'La fecha de vigencia es requerida',
        }),
      });
      return;
    }

    const hoy = moment().format('YYYY-MM-DD');
    if (form.fecha_desde < hoy) {
      this.setState({
        formError: intl.formatMessage({
          id: 'reglas.ociosidad_v2.validacion.fecha_retroactiva',
          defaultMessage: 'La fecha de vigencia no puede ser anterior a hoy',
        }),
      });
      return;
    }

    if (!form.fecha_desde_grilla) {
      this.setState({
        formError: intl.formatMessage({
          id: 'reglas.ociosidad_v2.validacion.fecha_desde_grilla_requerida',
          defaultMessage: 'La fecha desde la grilla es requerida',
        }),
      });
      return;
    }

    this.setState({ loading: true, errorBackend: null });
    Utils.sendDataNoErrorMessage(URL_OCIOSIDAD_V2, 'POST', {
      dias_sin_ruta: dias,
      ventana_procesamiento: form.ventana_procesamiento,
      fecha_desde: form.fecha_desde,
      fecha_desde_grilla: form.fecha_desde_grilla,
    })
      .then(() => {
        this.setState({
          guardado: true,
          loading: false,
          form: { dias_sin_ruta: '', ventana_procesamiento: VALOR_DIA_VENCIDO, fecha_desde: '', fecha_desde_grilla: '' },
        });
        this.cargarReglas();
      })
      .catch((err) => {
        const errorMsg = err && err.response && err.response.data && err.response.data.error;
        this.setState({
          errorBackend: errorMsg || intl.formatMessage({ id: 'reglas.ociosidad_v2.error.generico', defaultMessage: 'Ocurrió un error al guardar' }),
          loading: false,
        });
      });
  }

  render() {
    const { loading, reglas, errorBackend, form, formError, guardado } = this.state;
    const puedeModificar = Security.hasPermission('DISPONIBILIDAD_REGLAS_OCIOSIDAD_V2_MODIFICAR');
    const hoy = moment().format('YYYY-MM-DD');

    const vigente = reglas.reduce((acum, r) => {
      if (r.fecha_desde <= hoy && (!acum || r.fecha_desde > acum.fecha_desde)) return r;
      return acum;
    }, null);

    const reglasOrdenadas = reglas.slice().sort((a, b) => (b.fecha_desde > a.fecha_desde ? 1 : -1));

    return (
      <React.Fragment>

        {/* ── Formulario nueva versión (arriba) ── */}
        {puedeModificar && (
          <form className="form form-horizontal" onSubmit={this.handleSubmit}>
            <div className="form-body">
              <div className="card pull-up">
                <div className="card-content">
                  <div className="card-body">
                    <h4 className="form-section">
                      <i className="icon-settings"></i>{' '}
                      <FormattedMessage id="reglas.ociosidad_v2.nueva_version" defaultMessage=" Nueva versión" />
                      <div className="float-right" style={{ fontSize: '14px' }}>
                        <FormattedMessage id="disponibilidadReglas.form.campos_requeridos" defaultMessage="* campos requeridos" />
                      </div>
                    </h4>

                    {errorBackend && (
                      <div className="alert alert-danger">{errorBackend}</div>
                    )}
                    {guardado && (
                      <div className="alert alert-success">
                        <i className="fa fa-check-circle"></i>{' '}
                        <FormattedMessage id="reglas.ociosidad_v2.guardado" defaultMessage="Versión creada correctamente" />
                      </div>
                    )}

                    <div className="row">
                      <div className="col-md-6">

                        <div className="form-group row">
                          <label className="col-md-4 label-control col-form-label" htmlFor="dias_sin_ruta">
                            <FormattedMessage id="reglas.ociosidad_v2.form.dias" defaultMessage="Días sin ruta *:" />
                          </label>
                          <div className="col-md-8">
                            <div className="input-group">
                              <input
                                type="number"
                                id="dias_sin_ruta"
                                className={'form-control' + (formError ? ' is-invalid' : '')}
                                name="dias_sin_ruta"
                                min="1"
                                value={form.dias_sin_ruta}
                                onChange={this.handleFormChange}
                                disabled={loading}
                                placeholder="Ej: 5"
                              />
                              <div className="input-group-append">
                                <span className="input-group-text">días</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-4 label-control col-form-label" htmlFor="ventana_procesamiento">
                            <FormattedMessage id="reglas.ociosidad_v2.form.ventana" defaultMessage="Ventana *:" />
                          </label>
                          <div className="col-md-8">
                            <input
                              type="text"
                              id="ventana_procesamiento"
                              className="form-control"
                              value={VALOR_DIA_VENCIDO}
                              disabled
                            />
                            <small className="text-muted">
                              <FormattedMessage id="reglas.ociosidad_v2.form.ventana_nota" defaultMessage="Evalúa el día anterior completo (23:59:59)" />
                            </small>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-4 label-control col-form-label" htmlFor="fecha_desde">
                            <FormattedMessage id="reglas.ociosidad_v2.form.fecha_desde" defaultMessage="Vigente desde *:" />
                          </label>
                          <div className="col-md-8">
                            <input
                              type="date"
                              id="fecha_desde"
                              className={'form-control' + (formError ? ' is-invalid' : '')}
                              name="fecha_desde"
                              value={form.fecha_desde}
                              onChange={this.handleFormChange}
                              disabled={loading}
                            />
                            {formError && (
                              <div className="help-block text-danger field-message">{formError}</div>
                            )}
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-4 label-control col-form-label" htmlFor="fecha_desde_grilla">
                            <FormattedMessage id="reglas.ociosidad_v2.form.fecha_desde_grilla" defaultMessage="Grilla - Mostrar desde *:" />
                          </label>
                          <div className="col-md-8">
                            <input
                              type="date"
                              id="fecha_desde_grilla"
                              className={'form-control' + (formError ? ' is-invalid' : '')}
                              name="fecha_desde_grilla"
                              value={form.fecha_desde_grilla}
                              onChange={this.handleFormChange}
                              disabled={loading}
                            />
                            <small className="text-muted">
                              <FormattedMessage id="reglas.ociosidad_v2.form.fecha_desde_grilla_nota" defaultMessage="Ociosidades con inicio anterior a esta fecha no se muestran en la grilla Disponibilidad Activa. Puede ser retroactiva." />
                            </small>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-8 offset-md-4">
                        <button type="submit" className="btn btn-primary mr-1" disabled={loading}>
                          {loading
                            ? <i className="fa fa-spinner fa-spin"></i>
                            : <i className="fa fa-check-circle"></i>
                          }{' '}
                          <FormattedMessage id="reglas.ociosidad_v2.boton_crear" defaultMessage="Crear versión" />
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        )}

        {/* ── Grilla de versiones (abajo) ── */}
        <div className="row mt-2">
          <div className="col-12">
            <div className="card">
              <div className="card-content collapse show">
                <div className="card-body card-dashboard">
                  {loading && (
                    <div className="text-center py-3">
                      <i className="fa fa-spinner fa-spin fa-2x text-muted"></i>
                    </div>
                  )}
                  {!loading && (
                    <div className="table-responsive">
                      <table className="table nowrap table-hover">
                        <thead>
                          <tr style={{ color: '#ffffff', backgroundColor: '#241b3e' }}>
                            <th>#</th>
                            <th><FormattedMessage id="reglas.ociosidad_v2.tabla.dias_sin_ruta" defaultMessage="Días sin ruta" /></th>
                            <th><FormattedMessage id="reglas.ociosidad_v2.tabla.ventana" defaultMessage="Ventana" /></th>
                            <th><FormattedMessage id="reglas.ociosidad_v2.tabla.fecha_desde" defaultMessage="Vigente desde" /></th>
                            <th><FormattedMessage id="reglas.ociosidad_v2.tabla.fecha_desde_grilla" defaultMessage="Grilla desde" /></th>
                            <th><FormattedMessage id="reglas.ociosidad_v2.tabla.estado" defaultMessage="Estado" /></th>
                          </tr>
                        </thead>
                        <tbody>
                          {reglas.length === 0 ? (
                            <tr>
                              <td colSpan={6} className="text-center text-muted">
                                <FormattedMessage id="reglas.ociosidad_v2.sin_versiones" defaultMessage="Sin versiones configuradas" />
                              </td>
                            </tr>
                          ) : (
                            reglasOrdenadas.map((r, idx) => {
                              const esVigente = vigente && r.id === vigente.id;
                              const esFuturo = r.fecha_desde > hoy;
                              return (
                                <tr key={r.id}>
                                  <td>{reglas.length - idx}</td>
                                  <td>{r.dias_sin_ruta} días</td>
                                  <td>{r.ventana_procesamiento}</td>
                                  <td>{r.fecha_desde}</td>
                                  <td>{r.fecha_desde_grilla}</td>
                                  <td>
                                    {esVigente && (
                                      <span className="badge badge-success">
                                        <FormattedMessage id="reglas.ociosidad_v2.estado.vigente" defaultMessage="Vigente" />
                                      </span>
                                    )}
                                    {esFuturo && (
                                      <span className="badge badge-info">
                                        <FormattedMessage id="reglas.ociosidad_v2.estado.futuro" defaultMessage="Próximo" />
                                      </span>
                                    )}
                                    {!esVigente && !esFuturo && (
                                      <span className="badge badge-secondary">
                                        <FormattedMessage id="reglas.ociosidad_v2.estado.historico" defaultMessage="Histórico" />
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

      </React.Fragment>
    );
  }
}

export default injectIntl(ReglasOciosidadV2Card);
